





































import {Component} from "vue-property-decorator"
import Vue from "vue"
import JdiContent from "@/components/JdiContent.vue"

import JdiHeading from "@/components/JdiHeading.vue"
import JdiStatus from "@/components/JdiStatus.vue"
import JdsButton from "@/design-system/components/Button/JdsButton.vue"
import JdsLoader from "@/design-system/foundation/JdsLoader.vue"
import JdiPreview from "@/components/JdiPreview.vue"
import JdiButton from "@/components/JdiButton.vue"
import JdsToolbar from "@/design-system/patterns/JdsToolbar.vue"
import JdiPlaceholder from "@/components/JdiPlaceholder.vue"

@Component({
    components: {
        JdiPlaceholder,
        JdsToolbar, JdiButton, JdiPreview, JdsLoader, JdsButton, JdiStatus, JdiHeading, JdiContent}
})
export default class Loaders extends Vue {
    genericLoading = true;
    pw = '400px';
    ph = '400px';

    randomizePlaceholder () {
        this.pw = Math.floor(200 + Math.random() * 400) + 'px';
        this.ph = Math.floor(200 + Math.random() * 400) + 'px';
    }
}
